export function onlyDigits(s) {
  return (s || "").replace(/\D/g, "");
}

export function buildWhatsAppLink(number, message) {
  const n = onlyDigits(number);
  const text = encodeURIComponent(message || "");
  return `https://wa.me/${n}?text=${text}`;
}

export function categoryQuoteMessage(brandName, categoryLabel) {
  return `Olá, ${brandName}! Tenho interesse em um orçamento para *${categoryLabel}*. Poderia me ajudar?`;
}

export function leadWhatsAppMessage(brandName, lead) {
  const lines = [
    `Olá, ${brandName}! Gostaria de solicitar um orçamento.`,
    ``,
    `*Nome:* ${lead.name}`,
    lead.product_interest ? `*Produto:* ${lead.product_interest}` : "",
    lead.quantity ? `*Quantidade:* ${lead.quantity}` : "",
    lead.needed_date ? `*Data necessária:* ${lead.needed_date}` : "",
    lead.city_uf ? `*Cidade/UF:* ${lead.city_uf}` : "",
    lead.notes ? `*Observações:* ${lead.notes}` : "",
  ].filter(Boolean);
  return lines.join("\n");
}
